import React from 'react'

// TODO: use from @portal/lib/hooks
export function useOutsideClick(ref: React.RefObject<any>, onClick: () => void) {
    React.useEffect(() => {
        function handleClickOutside(event: Event) {
            if (ref.current && !ref.current.contains(event.target)) {
                onClick()
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [onClick, ref])
}
